import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumEmailDocumentGrouping implements BaseEnumType {
  private static allValues: EnumEmailDocumentGrouping[] = []; // make sure this is top-most
  
  public static unknown = new EnumEmailDocumentGrouping(0, "Unknown", "enum_email_document_grouping_unknown");
  public static multipleDocumentsPerAttachment = new EnumEmailDocumentGrouping(1, "MultipleDocumentsPerAttachment", "enum_email_document_grouping_multiple_documents_per_attachment");
  public static multipleSingleDocumentAttachmentsPerEmail = new EnumEmailDocumentGrouping(2, "MultipleSingleDocumentAttachmentsPerEmail", "enum_email_document_grouping_multiple_single_document_attachments_per_email");
  public static singleDocumentPerEmail = new EnumEmailDocumentGrouping(3, "SingleDocumentPerEmail", "enum_email_document_grouping_single_document_per_email");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumEmailDocumentGrouping.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isUnknown() { return this === EnumEmailDocumentGrouping.unknown; }
  public isMultipleDocumentsPerAttachment() { return this === EnumEmailDocumentGrouping.multipleDocumentsPerAttachment; }
  public isMultipleSingleDocumentAttachmentsPerEmail() { return this === EnumEmailDocumentGrouping.multipleSingleDocumentAttachmentsPerEmail; }
  public isSingleDocumentPerEmail() { return this === EnumEmailDocumentGrouping.singleDocumentPerEmail; }

  public static getValues(): readonly EnumEmailDocumentGrouping[] {
    return EnumEmailDocumentGrouping.allValues;
  }

  public static getValuesExcept0(): readonly EnumEmailDocumentGrouping[] {
    return EnumEmailDocumentGrouping.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumEmailDocumentGrouping {
    const found = EnumEmailDocumentGrouping.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumEmailDocumentGrouping - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumEmailDocumentGrouping): EnumEmailDocumentGrouping {
    const found = name ? EnumEmailDocumentGrouping.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumEmailDocumentGrouping - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumEmailDocumentGrouping>): boolean {
    return this.key === other?.key;
  }
}